import type { ReactNode } from 'react'
import { Item, ItemContent, ItemDescription, ItemMedia, ItemTitle } from '@/components/ui/item'
import { cn } from '@/lib/utils'

export interface ChoiceTileProps {
  title: ReactNode
  description?: ReactNode
  /** Logos or icons shown above the title. */
  media?: ReactNode
  /** Shows the tile as the current pick in a single-choice group. */
  selected?: boolean
  onSelect: () => void
  className?: string
}

/** A large clickable tile for picking one option out of a few — use in a grid, one tile per option. */
export function ChoiceTile({ title, description, media, selected, onSelect, className }: ChoiceTileProps) {
  return (
    <Item
      asChild
      variant="outline"
      className={cn(
        'h-full cursor-pointer flex-col items-start text-left hover:bg-accent/50',
        selected && 'border-primary ring-1 ring-primary',
        className,
      )}
    >
      <button type="button" aria-pressed={selected} onClick={onSelect}>
        {media && <ItemMedia>{media}</ItemMedia>}
        <ItemContent>
          <ItemTitle className="text-base">{title}</ItemTitle>
          {description && <ItemDescription className="text-pretty">{description}</ItemDescription>}
        </ItemContent>
      </button>
    </Item>
  )
}
